module.exports = __webpack_public_path__ + "static/media/ic_add_account.04bc0a1b.svg";